/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * GTM events after render page
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { IGTMOperation } from './index';

export const onPageView = (): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v268-e0',
    'event_cat': 'pageView',
    'event_name': 'viewInput',
    'event_param': '(empty)',
});

export enum EGTMPageDashboardAccountType {
    many = 'Много лицевых счетов',
    single = 'Один лицевой счет',
}

export const onPageDashboardView = (accountType: EGTMPageDashboardAccountType): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v268-e1',
    'event_cat': 'ЛС',
    'event_name': 'viewInput',
    'event_param': accountType,
});
